"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMonthName = void 0;
const MONTH_TO_NAME = {
    0: 'JANUARY',
    1: 'FEBRUARY',
    2: 'MARCH',
    3: 'APRIL',
    4: 'MAY',
    5: 'JUNE',
    6: 'JULY',
    7: 'AUGUST',
    8: 'SEPTEMBER',
    9: 'OCTOBER',
    10: 'NOVEMBER',
    11: 'DECEMBER',
};
function getMonthName(month) {
    const monthNum = month instanceof Date ? month.getMonth() : month;
    if (monthNum in MONTH_TO_NAME) {
        return MONTH_TO_NAME[monthNum];
    }
    throw new TypeError(`Invalid month: ${monthNum}.`);
}
exports.getMonthName = getMonthName;
